import { TFunction } from 'i18next'

import { TransactionOriginatorTypeGroup } from '@features/transactions/enums/transactionOriginatorTypeGroup'

export interface TransactionsFilterTypeGroup {
  label: string
  value: TransactionOriginatorTypeGroup
}

export const getTransactionsFilterTypeGroups = (t: TFunction): TransactionsFilterTypeGroup[] => [
  { label: t('transactions.table_actions.types.invoices'), value: TransactionOriginatorTypeGroup.Invoices },
  { label: t('transactions.table_actions.types.bills'), value: TransactionOriginatorTypeGroup.Bills },
  { label: t('transactions.table_actions.types.payments'), value: TransactionOriginatorTypeGroup.Payments },
  { label: t('transactions.table_actions.types.journals'), value: TransactionOriginatorTypeGroup.Journals },
  { label: t('transactions.table_actions.types.vat'), value: TransactionOriginatorTypeGroup.Vat },
]
